import $ from 'jquery';
import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const articleInfoSection = () => {
    const aboutInfoText = document.querySelectorAll('.article-content p, .article-gallery p');
    const imageContainers = document.querySelectorAll('.image-container');

    aboutInfoText.forEach((element, index) => {
        const articleTextSectionTl = gsap.timeline({
            paused: true
        });

        const text = new SplitText(element, { type: "lines" });
      
        gsap.set(".article-content p > div, .article-content .btn, .article-gallery p > div", {
            opacity: 0,
            y: 30
        });


        articleTextSectionTl.to(text.lines, {
            opacity: 1,
            y: 0,
            stagger: 0.125,
        }, 0.5).to('.article-content .btn', {
            opacity: 1,
            y: 0,
        }, 1.5);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: element,
            start: 'top bottom',
            end: 'bottom top',
            animation: articleTextSectionTl,
            toggleActions: 'play none none none',
        });
    });

    imageContainers.forEach((container, index) => {
        const articleInfoSectionTl = gsap.timeline({
            paused: true
        });

        articleInfoSectionTl.set(container, {
            className: "+= image-container active",
        }, 0.15);

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: container,
            start: 'top bottom-=250',
            end: 'bottom top',
            animation: articleInfoSectionTl,
            toggleActions: 'play none none none',
        });
    });
};

export default articleInfoSection;
